import { Col, Divider, Form, InputNumber, Row, Modal, Space, Button, message, Table, Typography } from "antd";
import { useState, useEffect } from "react";
import { useWatch } from "antd/es/form/Form"; 
import AnimateItems from "../../../utils/AnimateItems";
import axios from "axios";
import { useAuth } from "../../../layout/auth";

export default function MontoForm(props) {
  const { title, visible, mainData: verification, setMainData: setVerification, setVisible } = props;
  const [aranceles, setAranceles] = useState();
  const [currentMonto, setCurrentMonto] = useState(0);
  const [currentComisionUnidad, setCurrentComisionUnidad] = useState(0);
  const [currentComisionVerificador, setCurrentComisionVerificador] = useState(0);

  const [form] = Form.useForm();

  const auth = useAuth();

  const distancia = useWatch("DistanciaArancel", form);

  useEffect(() => {
    if (!verification || distancia == null) return;

    const { ClasificacionSCIANID, TipoVerificacionID, AlcanceVerificacion } = verification;

    const fetchArancel = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/utils/arancel_2025`, {
          params: {
            scian_id: ClasificacionSCIANID,
            type_id: TipoVerificacionID,
            power_kw: AlcanceVerificacion,
            distance_km: 0,
          },
        });

        setAranceles(response.data);

        const monto = response.data.cost;

        form.setFieldsValue({ Monto: monto });
        form.setFieldsValue({ ComisionUnidad: monto * 0.4 });
        form.setFieldsValue({ ComisionVerificador: monto * 0.6 });
        setCurrentMonto(monto);
        setCurrentComisionUnidad(monto * 0.4);
        setCurrentComisionVerificador(monto * 0.6);
      } catch (error) {
        console.error("Error fetching arancel:", error);
      }
    };

    fetchArancel();
  }, [distancia, verification]);

  useEffect(() => {
    if (visible && verification) {
      setCurrentMonto(verification?.Monto);
      setCurrentComisionUnidad(verification?.ComisionUnidad);
      setCurrentComisionVerificador(verification?.ComisionVerificador);
    }
  }, [visible, verification]);

  const handleMontoChange = (value) => {
    setCurrentMonto(value);
  };

  const handleComisionUnidadChange = (value) => {
    setCurrentComisionUnidad(value);
  };

  const handleComisionVerificadorChange = (value) => {
    setCurrentComisionVerificador(value);
  };

  const columns = [
    {
      title: "Alcance (kW)",
      dataIndex: "power_kw",
      key: "power_kw",
    },
    {
      title: "Tarifa (MXN)",
      dataIndex: "cost",
      key: "cost",
    },
  ];

  return (
    <Modal title={title} visible={visible} onCancel={() => setVisible(false)} footer={null} width={800}>
      <Form form={form} layout="vertical" initialValues={verification}>
        <AnimateItems delay={0.15}>
          <Row gutter={[16, 0]}>
            <Col span={12}>
              <Row gutter={[16, 0]}>
                <Col span={24}>
                  <Form.Item name="DistanciaArancel" label="Distancia aproximada (informativo)" rules={[{ required: true, message: "Campo requerido" }]}>
                    <InputNumber min={0} addonAfter={"KM"} />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item name="Monto" label="Monto">
                    <InputNumber
                      min={0}
                      addonBefore="$"
                      addonAfter={"MXN"}
                      onChange={handleMontoChange}
                      disabled={auth?.Rol !== "director"}
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item name="ComisionUnidad" label="Comision Unidad">
                    <InputNumber
                      min={0}
                      addonBefore="$"
                      addonAfter={
                        currentComisionUnidad && currentMonto ? `${Math.round((currentComisionUnidad / currentMonto) * 100)}%` : "0%"
                      }
                      onChange={handleComisionUnidadChange}
                      disabled={auth?.Rol !== "director"}
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item name="ComisionVerificador" label="Comision Verificador">
                    <InputNumber
                      min={0}
                      addonBefore="$"
                      addonAfter={
                        currentComisionVerificador && currentMonto
                          ? `${Math.round((currentComisionVerificador / currentMonto) * 100)}%`
                          : "0%"
                      }
                      onChange={handleComisionVerificadorChange}
                      disabled={auth?.Rol !== "director"}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Col>
            <Col span={12}>
              <Typography.Title level={5} type="secondary">
                Aranceles {aranceles?.listUsed.name}
              </Typography.Title>
              <Table
                columns={columns}
                dataSource={aranceles?.listUsed.values}
                size="small"
                pagination={{
                  pageSize: 100,
                }}
                scroll={{
                  y: 240,
                }}
              />
            </Col>
          </Row>
        </AnimateItems>
      </Form>
      <div style={{ textAlign: "right" }}>
        <Space>
          <Button
            type="primary"
            onClick={() => {
              const comisionSum = currentComisionUnidad + currentComisionVerificador;
              if (comisionSum !== currentMonto) {
                message.error("La suma de las comisiones debe ser igual al monto.");
                return;
              }

              const verificationData = { ...verification, ...form.getFieldsValue() };
              axios
                .put(`${process.env.REACT_APP_API_URL}/verificaciones/${verification?.VerificacionID}`, verificationData)
                .then(() => {
                  setVisible(false);
                  axios.get(`${process.env.REACT_APP_API_URL}/verificaciones/${verification?.VerificacionID}`).then((res) => {
                    setVerification(res.data[0]);
                    message.success("Campos actualizados correctamente");
                  });
                })
                .catch((err) => {
                  console.log(err);
                  message.error("Error al actualizar los campos");
                });
            }}
          >
            Guardar
          </Button>
          <Button
            onClick={() => {
              setVisible(false);
            }}
          >
            Cancelar
          </Button>
        </Space>
      </div>
    </Modal>
  );
}
